module.exports = __webpack_public_path__ + "img/speck-mascarpone.ca61cf2e.jpg";